// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_i6-1";
export var rowFirst = "_i6-3";
export var rowLast = "_i6-5";
export var rowMiddle = "_i6-4";
export var ticketListScroll = "_i6-2";
export var ticketStack = "_i6-0";